import { Eyebrow, Reveal } from "./shared";

const PRINCIPLES = [
    {
        title: "International Perspective",
        copy: "We work across borders, cultures and labour markets — and understand what global mobility truly requires.",
    },
    {
        title: "Human-Centered Service",
        copy: "Behind every placement is a person. We take time to understand goals, not just CVs.",
    },
    {
        title: "Structured Processes",
        copy: "Clear steps, honest communication and careful documentation at every stage of the journey.",
    },
    {
        title: "Technology-Enabled Support",
        copy: "Modern tools that keep clients and candidates informed from first inquiry to deployment.",
    },
];

export const WhyAfrinexa = () => (
    <section id="about" data-testid="why-afrinexa-section" className="bg-ivory py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <Reveal>
                <Eyebrow>Why Afrinexa</Eyebrow>
                <h2 className="mt-5 max-w-3xl font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
                    Built Around People. Connected to the World.
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-x-16 md:grid-cols-2">
                {PRINCIPLES.map((principle, i) => (
                    <Reveal key={principle.title} delay={i * 0.08}>
                        <div
                            data-testid={`principle-${principle.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            className="flex gap-6 border-t border-ink/10 py-8 lg:gap-10"
                        >
                            <span className="font-serif text-2xl font-medium text-forest/35">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div>
                                <h3 className="text-lg font-medium tracking-tight text-ink">
                                    {principle.title}
                                </h3>
                                <p className="mt-2 max-w-md text-sm leading-relaxed text-ink/60">
                                    {principle.copy}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
            <div className="border-t border-ink/10" />
        </div>
    </section>
);
